import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import { fetchAPI } from '@/api';

function TelegramBot() {
	let auth = useSelector(state => state.auth);

	useEffect(() => {
		const fetchData = async () => {
			const response = await fetchAPI("/billing/status", auth.user.token);

			if (!response.ok) {
				throw new Error(`This is an HTTP error: The status is ${response.status}`);
			}
			let data = await response.json();

		}

		fetchData();
	}, []);

	return (
		<StaticLayoutInner>
			<h1 className="h1 col-start-1 col-end-2 mb-4">
				Telegram bot
			</h1>
		</StaticLayoutInner>
	);
}

export default TelegramBot;
